import { AWS_CONFIG } from "../config/AWS";

export const verifyPurchase = async (email) => {
  try {
    const url = `${AWS_CONFIG.Lambda_URL}?email=${email}`;
    console.log("URL:", url);
    const response = await fetch(url, {
      method: "GET",
      mode: "cors", // Added to handle CORS issues
    }).then((res) => {
      return res.json();
    });

    console.log("Response:", response);

    const validPurchase = response === true;
    console.log("Valid purchase found:", validPurchase);
    return validPurchase;
  } catch (error) {
    console.error("Error verifying purchase:", error);
    throw error;
  }
};
